import React, { useState } from 'react';
import axios from 'axios';
import { Intent, Classes ,H3} from "@blueprintjs/core";
import { Button, Card, Elevation,Slider, Overlay } from "@blueprintjs/core";
import CardViewerAudio from './CardViewerAudio.tsx';
import CardEditorForTeacher from "./CardEditorForTeacher.tsx";
import CardObject from "./CardObject.tsx";
import CardImage from './CardImage.tsx';
import {CardPdf} from './CardPdf.tsx'
import CardDocumentWeb from './CardDocumentWeb.tsx';

export default class CardMesEnregistrementsEnseignants extends React.Component  <{}> {
    state = {
        aideenregistrementaudio:false,
        deleterecord:-1,
        mustRefresh:false,
        mustReload:false,
        recordings:[],
        recordingsbydate:[],
        select_id_matiere:0,
        id_classe:0,
        eleve_selected_todocument:this.props.eleve_selected_todocument,
        nom_student_select:''
    }
    componentDidMount () {
        this.setState({mustReload:true});
        this.setState({eleve_selected_todocument:this.props.eleve_selected_todocument});
     }
    componentDidUpdate(prevProps: Readonly<{}>, prevState: Readonly<{}>, snapshot?: any): void {
      if(this.props.eleve_selected_todocument!=this.state.eleve_selected_todocument)
      {
          this.setState({eleve_selected_todocument:this.props.eleve_selected_todocument});
          this.setState({mustReload:true});
      }  
      if(this.props.id_classe!=this.state.id_classe)
        {
            this.setState({id_classe:this.props.id_classe});
            this.setState({mustReload:true});
        }
        if(this.state.mustReload)
        {
            this.setState({mustReload:false});
            this.loadStudentDocument(this.props.userid,this.props.id_classe).then(documents=>
                {
                  //console.log(documents);
                  //setStudentDocument(documents);
                  var obj=[];
                  var objdate=[];
                  if(documents==null){this.setState({recordings:[]});this.setState({recordingsbydate:[]});return;}
                  documents.map((item)=>{
                    var nom="";
                    this.props.students.filter(it=>it.ID == item.id_student).map((it)=>nom=it.nickname);
                    console.log(nom);
                    if(this.state.eleve_selected_todocument==-1)
                    {
                    var st={id:item.ID,CreatedAt:item.CreatedAt,nom_etudiant:nom,id_matiere:item.id_matiere, title:item.title,date:item.date_record,data:item.url,type:item.type,id_student:item.id_student,id_document:item.objectif};
                    obj.push(st);
                    var dd=st.date.split(',');
                    var nb=objdate.filter(st=>st.datedujour == dd[0]).length
                    var stitem2={datedujour:dd[0],creationdate:item.CreatedAt,selected:false,recordings:[]};
                    if(nb==0)objdate.push(stitem2);
                    objdate.map((item2)=>{
                      if(item2.datedujour==dd[0]) item2.recordings.push(st);
                    });
                   }
                   else
                   {
                    var nom2="";
                    this.props.students.filter(it=>it.ID == this.state.eleve_selected_todocument).map((it)=>nom2=it.nickname);
                    this.setState({nom_student_select:nom2});
                    if(this.state.eleve_selected_todocument==item.id_student)
                    {
                    var st={id:item.ID,CreatedAt:item.CreatedAt,nom_etudiant:nom,id_matiere:item.id_matiere, title:item.title,date:item.date_record,data:item.url,type:item.type,id_student:item.id_student,id_document:item.objectif};
                    obj.push(st);
                    var dd=st.date.split(',');
                    var nb=objdate.filter(st=>st.datedujour == dd[0]).length
                    var stitem2={datedujour:dd[0],creationdate:item.CreatedAt,selected:false,recordings:[]};
                    if(nb==0)objdate.push(stitem2);
                    objdate.map((item2)=>{
                      if(item2.datedujour==dd[0]) item2.recordings.push(st);
                    });
                    }
                   }
                  });
                  
                  this.setState({recordings:obj});
                  this.filterStudentDocuments(objdate,this.state.select_id_matiere)
                })
        }
    }
sortByKey=(array, key)=> {
        return array.sort((a, b) => {
          let x = a[key];
          let y = b[key];
          
          return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
}
sortByKeyDesc=(array, key)=> {
    return array.sort((a, b) => {
      let x = a[key];
      let y = b[key];
      
      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
}
filterStudentDocuments=(objdate,idm)=>
{
    objdate.map((item2)=>{
    var nb=0;
    
    item2.timestamp=new Date(item2.creationdate).getTime()/1000;
   // console.log(item2.timestamp);
    item2.visible=true
    if(idm>0)
    {
        item2.recordings.map((item3)=>{
            if(item3.id_matiere==idm){item3.visible=true;nb++;}else{item3.visible=false;}
        })
    }
    else
    {
            item2.recordings.map((item3)=>{
                item3.visible=true;
                nb++;
            })
    }
    if(nb==0)item2.visible=false;
    
    });
    
    //this.setState({recordingsbydate:objdate.reverse()});
    objdate=this.sortByKey(objdate,'timestamp');
    objdate=objdate.reverse();
    this.setState({recordingsbydate:objdate});
}
loadStudentDocument=async(id_enseignant,id_classe)=>
    {
      const response = await fetch('/api/public/getstudentdocumentbyidenseignant?id_enseignant='+id_enseignant+"&id_classe="+id_classe);
      const documents = await response.json();
      return documents;
    }
setAideenregistrementaudio=(ev)=>{this.setState({aideenregistrementaudio:ev})}
setDeleterecord=(ev)=>{this.setState({deleterecord:ev})}
handletaille=()=>{}
renderStudentDocument = (item) => {
    
    if (item.type=="")item.type="object";
    if (item.type=="audio")return(<CardViewerAudio id_document={item.id} url_video={item.data}/>)
    if (item.type=="text")return (<div style={{backgroundColor:'#fff',padding: 5,margin: 5, borderRadius:5}}><div style={{borderRadius:5,backgroundColor: '#fff2e5', padding: '4px 6px', marginBottom: 5,width: 'fit-content'}}>Document travaillé : {item.title}</div>
        <CardEditorForTeacher _onUploadtext={this.props._onUploadtext}  handletaille={this.handletaille} userid={item.id_student} recordingsbydate={this.state.recordingsbydate} matiere_id={item.id_matiere} id_document={item.id_document} title_document={item.title}/></div>)
    if (item.type=="object") return(<div style={{backgroundColor:'#fff',padding: 5,margin: 5, borderRadius:5}}><div style={{borderRadius:5,backgroundColor: '#fff2e5', padding: '4px 6px', marginBottom: 5,width: 'fit-content'}}>Document travaillé : {item.title}</div>
    <CardObject id_document={item.ID}url_video={item.data} objectif={item.objectif} title_document={item.title} description={item.description}/></div>)
    if (item.type =="pdf" ) {
        return ( <div style={{backgroundColor:'#fff',padding: 5,margin: 5, borderRadius:5}}><div style={{borderRadius:5,backgroundColor: '#fff2e5', padding: '4px 6px', marginBottom: 5,width: 'fit-content'}}>Document travaillé : {item.title}</div>
          <CardPdf   id_document={item.ID}url_video={item.data} objectif={item.objectif} title_document={item.title} description={item.description}/></div>
        );
    }
    if (item.type =="web" ) {
        return (  
            <div style={{backgroundColor:'#fff',padding: 5,margin: 5, borderRadius:5}}><div style={{borderRadius:5,backgroundColor: '#fff2e5', padding: '4px 6px', marginBottom: 5,width: 'fit-content'}}>Document travaillé : {item.title}</div>
          <CardDocumentWeb  id_document={item.ID}url_video={item.data} objectif={item.objectif} title_document={item.title} description={item.description}/></div>
        );
    }
    if (item.type=="image") {
        return (
            <div style={{backgroundColor:'#fff',padding: 5,margin: 5, borderRadius:5}}><div style={{borderRadius:5,backgroundColor: '#fff2e5', padding: '4px 6px', marginBottom: 5,width: 'fit-content'}}>Document travaillé : {item.title}</div>
            <CardImage    id_document={item.ID}url_video={item.data} objectif={item.objectif} title_document={item.title} description={item.description}/></div>
        );
    }
    return(null)
    
}
renderItemRecordDetails=(item)=>
{
    return(
    item.visible?<ul style={{ listStyle: "none", padding: 0 }}>
    <li style={{backgroundColor: '#aae1ff',padding: 10,borderRadius: 10,boxShadow: '2px 2px 8px #aaa'}}>
      <div><div style={{borderRadius:5,backgroundColor: '#fff2e5', padding: '4px 6px', marginBottom: 5,width: 'fit-content'}}>{item.nom_etudiant}</div><div style={{fontSize:9}}> {item.date}</div><div>{item.type=="audio"?<Button onClick={()=>this.downloadAs(item.data,item.nom_etudiant+"_"+item.date)} icon="cloud-download">Télécharger</Button>:null}<Button style={{margin:'0 4px'}} onClick={(ev)=>this.setState({deleterecord:item.id})} icon="trash"></Button></div></div>
      {this.renderStudentDocument(item)}
    </li>
    </ul>:null)
}
downloadFile=(filePath)=>{
    var link=document.createElement('a');
    link.href = filePath;
    link.download = filePath.substr(filePath.lastIndexOf('/') + 1);
    link.click();
}
downloadAs = (url, name) => {
    axios.get(url, {
      headers: {
        "Content-Type": "application/octet-stream"
      },
      responseType: "blob"
    })
      .then(response => {
        const a = document.createElement("a");
        const url = window.URL.createObjectURL(response.data);
        a.href = url;
        a.download = name;
        a.click();
      })
      .catch(err => {
        console.log("error", err);
      });
  };
renderItemRecord=(itemr)=>
{
  return (itemr.visible?<div style={{padding:3}}><Button style={{marginRight:10}} icon={itemr.selected?"minus":"plus"} onClick={(ev)=>{itemr.selected=!itemr.selected;this.setState ({mustRefresh:!this.state.mustRefresh});}}/><span>{itemr.datedujour}</span><div>{itemr.selected ==true ?itemr.recordings.map(p => this.renderItemRecordDetails(p)):null} </div></div>:null)
}
EffacerEnregistrement=(id)=>
{

}
render() {

const {aideenregistrementaudio,deleterecord,recordingsbydate,recordings}=this.state;
const {setAideenregistrementaudio,setDeleterecord,renderItemRecord,EffacerEnregistrement}=this;
return(

<div style={{minWidth:700,width:'100%',display:"flex",flexDirection: 'column',boxShadow:' 0 0 0 1px rgb(16 22 26 / 10%), 0 1px 1px rgb(16 22 26 / 20%), 0 2px 6px rgb(16 22 26 / 20%)', padding: 20,margin: 5,backgroundColor: '#fff'}}>
      <h3><a onClick={(ev)=>{ev.preventDefault();setAideenregistrementaudio(true)}}>Les enregistrements de {this.state.eleve_selected_todocument==-1?"mes étudiants":this.state.nom_student_select}</a></h3>
      <Overlay isOpen={aideenregistrementaudio} className={Classes.OVERLAY_SCROLL_CONTAINER} >
          <div style={{ color: '#444', background: '#fff', padding: '30px 50px 20px', width: '50%',margin: '120px 25%'}}>
                        <H3>Les enregistrements de mes étudiants</H3>
                        <p>
                           Retrouvez ici tous les enregistrements et documents déposés par vos étudiants de la classe que vous avez sélectionné.
                        </p>
                       
                        <div>
                        
                        </div>
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.DANGER} onClick={(ev)=>{ev.preventDefault();setAideenregistrementaudio(false)}} style={{ margin: "" }}>
                                Fermer
                            </Button>
                            
                            
                        </div>
                    </div>
      </Overlay>
      <Overlay isOpen={deleterecord>-1} className={Classes.OVERLAY_SCROLL_CONTAINER} >
                    <div style={{ color: '#444', background: '#fff', padding: '30px 50px 20px', width: '50%',margin: '120px 25%'}}>
                        <H3>Effacer un enregistrements audio</H3>
                       
                        <p>
                            Êtes-vous sur de vouloir effacer votre enregistrement?
                        </p>
                        <p>
                          Détails: enregistrement du <span icon="date"><b>{recordings.map((item)=>{if(item.id==deleterecord) return item.date})}</b></span>
                        </p>
                        <p></p>
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.DANGER} onClick={(ev)=>{ev.preventDefault();setDeleterecord(-1);}} style={{ margin: "" }}>
                                Annuler
                            </Button>
                            <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();setDeleterecord(-1);EffacerEnregistrement(deleterecord);}} style={{ margin: "" }}>
                                Effacer
                            </Button>
                            
                            
                        </div>
                    </div>
      </Overlay>
        <div>
        {recordingsbydate.map(p => renderItemRecord(p))}
        </div>
      </div>
    )}

}